import React from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import '../styles/contact.css';
import '../styles/contactForm.css'
import ContactForm from '../components/contactForm';
import useScrollAnimation from '../hooks/useScrollAnimation';

function ContactPage() {
  useScrollAnimation();

  return (
    <>
      <Navbar />

      <section className="contact-page">
        <h1 className="fade-in">Contact Us</h1>
        <p className="fade-in-delay">We’re here to answer your questions and provide assistance. Reach out to us anytime!</p>

        <div className="contact-page-content">

          {/* Embedded Google Map */}
          <div className="map-container slide-left">
            <iframe
              src="https://www.google.com/maps?q=Mirror+Lake+Pharmacy+Care+Clinic+Camrose&output=embed"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Mirror Lake Pharmacy Location"
            ></iframe>

          </div>

          {/* Contact Form */}
          <div className="slide-right">
            <ContactForm />

          </div>

        </div>

        <section className="pharmacist-info">
          <div className="pharmacist-info-header fade-in">
            <h2>Pharmacist Information</h2>
            {/* <p>
              <strong>Pharmacy License: </strong>
              <a href="/assets/Pharmacy_Liscense.pdf" target="_blank" rel="noopener noreferrer">
                <u>4625</u>
              </a>
            </p> */}
          </div>
          <p className="fade-in-delay">
            Our Pharmacy Team is here to help you manage your medications, answer your questions,
            and provide the advice to help you take care of your health. With convenient hours and
            locations and a Pharmacist always available during store hours, we make managing your
            health easier.
          </p>
          <p className="fade-in-delay-2">
            Our Pharmacy Manager, at the request of the patient, will provide the name and practice
            number for any regulated member who provides a service to a patient in our store.
          </p>
          <p className="fade-in-delay-3">
            Click <a href="https://abpharmacy.ca/wp-content/uploads/Poster_PatientConcerns.pdf" target="_blank" rel="noopener noreferrer"><strong>here</strong></a> to go to the Alberta College of Pharmacy website to view the Patient Concerns poster.
          </p>

          <div className="pharmacist-details">
            <div className='pharmacist-photo slide-up-delay-1'>
              <img src="/assets/avatar1.png" alt="Pharmacist Owner" />
              <p><strong>Pharmacist Owner</strong><br />Cameron Delong</p>
            </div>
            <p className="slide-up-delay-2"><strong>Proprietor's Representative Name</strong><br />Dhaval Patel</p>
            <p className="slide-up-delay-3"><strong>Pharmacy Licensee</strong><br /><a href="/assets/Pharmacy_Liscense.pdf" target="_blank" rel="noopener noreferrer">
              <u>4625</u>
            </a></p>
            <p className="slide-up-delay-4"><strong>Pharmacist Licensee</strong><br />
              {/* <a href="/assets/Pharmacy_Liscense.pdf" target="_blank" rel="noopener noreferrer">
              <u>11189</u>
            </a> */}
            11189
            </p>
          </div>
        </section>
      </section>

      <Footer />
    </>
  );
}

export default ContactPage;